import React from "react";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./EventProductionInfo.css";
import productionImg from "../../assets/event-28.jpg";

const EventProductionInfo = () => {
  return (
    <section className="info">
      <Container className="company-info">
        <Row>
          <Col lg={8} className="slide-in-left">
            <h1 className="text-primary2 fw-bold mb-4 text-center text-lg-start">
              Event Production
            </h1>
            <Row className="align-items-center">
              <Col xs={12} md={6} className="mb-4 mb-md-0 text-center">
                <img
                  src={productionImg}
                  alt="Event Production"
                  className="img-fluid company-image"
                />
              </Col>
              <Col xs={12} md={6} className="text-white">
                <h4 className="text-white mb-3 text-center text-md-start">
                  Our Event Production Services
                </h4>
                <ul className="event-services-list ps-3">
                  <li>Event Design and Theme Development</li>
                  <li>Stage Design and Setup</li>
                  <li>Lighting Design and Implementation</li>
                  <li>Sound System Setup and Management</li>
                  <li>Visual Effects and Multimedia Integration</li>
                  <li>Logistics Management</li>
                  <li>Live Streaming and Virtual Event</li>
                  <li>On-Site Event Management</li>
                </ul>
              </Col>
            </Row>
            <p className="text-white mt-4">
              Zarinova Entertainment is your go-to partner for premier event
              production services. We specialize in transforming your ideas into
              extraordinary experiences, ensuring that every detail is
              meticulously planned and executed. Whether you're hosting a
              corporate conference, a product launch, a gala, or a large-scale
              public event, Zarinova Entertainment provides comprehensive
              production services that guarantee a seamless and impactful event.
              Our expert team handles everything from conceptualization and
              design to technical execution and on-site management.
            </p>
          </Col>

          <Col lg={4} className="slide-in-right">
            <Card className="get-in-touch-card mt-4">
              <Card.Body>
                <h5 className="fw-bold text-white">GET IN TOUCH</h5>
                <p className="small text-white">
                  PLEASE FILL THE FORM FOR ANY QUERY OR SUGGESTION
                </p>
                <Form>
                  <Form.Group className="mb-3" controlId="formFullName">
                    <Form.Control type="text" placeholder="FULL NAME" />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formEmail">
                    <Form.Control type="email" placeholder="EMAIL ADDRESS" />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formComment">
                    <Form.Control
                      as="textarea"
                      rows={3}
                      placeholder="YOUR COMMENT"
                    />
                  </Form.Group>

                  <Button
                    variant="warning1"
                    className="learn-more-btn rounded-pill px-4 py-2 text-white w-100"
                    type="submit"
                  >
                    SUBMIT
                  </Button>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default EventProductionInfo;
